import { toast } from 'react-toastify';
import { iTHREE } from '@treedis/tour-loader';
import { SweepPath } from '@/_models/Sweep';
import { getQueryVariable, getSweepsPath } from '../util';

export const processNavigationPath = async ({
  tagNavigationLink: url,
  sweeps,
  startSweep,
  cb,
}: {
  tagNavigationLink: any;
  sweeps: any[];
  startSweep: any;
  cb: ({ sweepsPath, rotation }: { sweepsPath: any; rotation: any }) => void;
}) => {
  const THREE = await iTHREE();

  const sr = getQueryVariable(url, 'sr');
  const ss = getQueryVariable(url, 'ss');
  const linkDataShort: any = sr && ss ? { sr: sr.split(','), ss: parseInt(String(ss), 10) } : false;

  if (linkDataShort) {
    const x = parseFloat(linkDataShort.sr[0] || '0');
    const y = parseFloat(linkDataShort.sr[1] || '0');
    const z = parseFloat(linkDataShort.sr[2] || '0');

    const euler = new THREE.Euler().set(x, y, z, 'XYZ').reorder('YXZ');
    const rotation = new THREE.Vector3(euler.x, euler.y, euler.z).multiplyScalar(180 / Math.PI); // @ts-ignore

    rotation.z = 0;
    const endSweep = sweeps[linkDataShort.ss - 1].uuid;
    const sweepsPath: SweepPath[] = getSweepsPath(sweeps, startSweep, endSweep);
    cb({
      sweepsPath,
      rotation,
    });
  } else {
    toast.error('Wrong matterport deep link');
  }
};
